import {
  AfterContentInit, ChangeDetectorRef,
  Component,
  ContentChildren, ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList, SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {LocaleService} from '../../../../../src/app/shared/services/locale.service';
import {extractValue} from '../standard-form-builder/standard-form.helpers';
import {DomSanitizer} from '@angular/platform-browser';
import {InsparkMessageService, InsparkTemplate} from '@inspark/inspark-components';
import {copy2clipboard} from '../../../../../src/app/shared/functions/copy2clipboard';
import { TranslateService } from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import _ from 'lodash';
import {
  ComposeBusinesscontrparamsModalComponent
} from '../../../../admin/modules/businessparams/compose-businesscontrparams-modal/compose-businesscontrparams-modal.component';
import {gettext} from '../../../../../src/app/shared/gettextMarker.function';
import {LocalStorageService} from '../../../../api/src/locale-storage/locale-storage.service';
import {DialogService} from 'primeng/dynamicdialog';
import {ParamlistsApiService} from '../../../../api/src/paramlist/paramlists-api.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalRuleactionModel} from '../../../../api/src/globalrule/globalrule.model';
import {
  ComposeUnitsModalComponent
} from '../../../../admin/modules/unit/compose-units-modal/compose-units-modal.component';
import {ObjectsShortestApiService} from '../../../../api/src/object/objects-shortest-api.service';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-globalruleaction-form-builder',
  templateUrl: './globalruleaction-form-builder.component.html',
  styleUrls: ['./globalruleaction-form-builder.component.scss'],
  standalone: false
})
export class GlobalruleactionFormBuilderComponent implements OnInit, AfterContentInit, OnChanges, OnDestroy {
  @Input() section: any = {};
  @Input() globalrule: any = {};
  @Input() ruleaction: any = {};
  @Input() ruleactions: any[] = [];
  // @Input() selactions: any[];
  @Input() typicalconfigId: number;
  @Input() isCondition  = false;
  @ViewChild('in', { static: false }) inputEL: ElementRef;


  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any;
  @Input() itemOptions: any = {};
  @Input() buttons;
  @Input() buttonsLabels: { save?: string; create?: string; copy?: string; delete?: string; savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string } =
    {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', operatingmode: 'OPERATINGMODE', timeschedule: 'TIMESCHEDULE', upload: 'UPLOAD'};
  @Input() inAction = false;
  @Input() testEntryPointSelector = 'form_builder';
  @Input() disabled = {save: false, create: false, copy: false};
  @Input() inTemplates: QueryList<InsparkTemplate>;
  @Output() save = new EventEmitter<any>();
  @Output() root = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() createCondition = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() ruleactionChange = new EventEmitter<any>();
  @ContentChildren(InsparkTemplate) templates: QueryList<InsparkTemplate>;
  public sectionsState: any = {conditions: true, overview: true, actions: true};
  private isChanged = false;
  private hasNotSavedParameter = false;
  private hasNotSavedValue = false;
  private hasNotSavedRoot = false;
  filteredContrDeviceparamsSingle: any[];
  filteredUnitsSingle: any[];
  //selectedDeviceparam: any = {label: 'Select deviceparam', value: null};
  filteredSelContrDeviceparams: any[] = [];
  filteredSelUnits: any[] = [];

  allRuleActions: any[];
  filteredRuleActionsSingle: any[];
  selectedRuleAction: any = {label: 'Select ruleaction', value: null};
  filteredSelActions: any[] = [];

  filteredRuleCmdsSingle: any[] = [];
  filteredRuleCmdsSingle_keep: any[] = [];
  filteredRuleActionsMultiple: any[];

  extCommand: any;

  checkDdlFlag = false;
  checkDdlFlag2 = false;

  id_keep;

  emptyOption = {
    label: null,
    value: null
  };
  // tslint:disable-next-line:max-line-length
  public readonly svgInfo = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>';

  public svg;

  readonly DEFAULT_MAX_LENGTH = 65535;
  bodyTemplate: TemplateRef<any>;
  valueTemplate: TemplateRef<any>;
  calendarLocale;
  localesub;
  isValidPattern = true;
  enterPress = false;
  isFastProccession = true;
  public refWindow: any;
  globalruleactions: GlobalRuleactionModel[];
  globalruleactions2: GlobalRuleactionModel[];
  //globalrule: GlobalRuleModel;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private localeService: LocaleService,
    private localStorageApi: LocalStorageService,
    private dialogService: DialogService,
    private paramlistApi: ParamlistsApiService,
    private objectsShortestApi: ObjectsShortestApiService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private http: HttpClient,
    private messageService: InsparkMessageService,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit() {

    this.svg = this.sanitizer.bypassSecurityTrustHtml(this.svgInfo);

    if (this.itemOptions?.contrdeviceparams && this.itemOptions?.contrdeviceparams.length < 500) {
      this.isFastProccession = true;
      this.filteredSelContrDeviceparams = _.cloneDeep(this.itemOptions.contrdeviceparams);
    } else if (this.itemOptions?.units && this.itemOptions?.units.length < 500) {
        this.isFastProccession = true;
        this.filteredSelUnits = _.cloneDeep(this.itemOptions.units);
    } else {
      this.isFastProccession = false;
    }
    this.section.objtype = 'contrdeviceparam';
    if (this.ruleaction?.unit) {
      this.section.objtype = 'unit';
      this.ruleaction.unit.label = this.ruleaction.unit?.value?.deviceconnect?.device?.devicename;
      //this.ruleaction.extCommand.label = this.ruleaction.extCommand.name;
      if (!this.ruleaction.extCommand?.label && this.ruleaction.extCommand.value) {
        this.ruleaction.extCommand.label = this.ruleaction.extCommand?.value.name;
      }
      this.filteredSelActions = _.cloneDeep(this.itemOptions.units);
    } else if (this.ruleaction?.contrDeviceParam) {
      this.section.objtype = 'contrdeviceparam';
      this.filteredSelActions = _.cloneDeep(this.itemOptions.contrdeviceparams);
    } else {
      //this.section.objtype = 'all';
    }
  }

  ngOnDestroy() {
    if (this.localesub) {
      this.localesub.unsubscribe();
    }
  }

  onActionChange0(event) {

    if (event.id) {
      //this.ruleaction = event;
      this.ruleaction = _.cloneDeep(this.ruleactions.filter(rule => rule.id === event.id)[0]);
      if (this.ruleaction.contrDeviceParam) {
        if (!this.ruleaction.contrDeviceParam.value) {
          this.ruleaction.contrDeviceParam = {label: this.ruleaction.action.value, value: this.ruleaction.contrDeviceParam};
        }
        this.section.objtype = 'contrdeviceparam';
      } else if (this.ruleaction.unit) {
        if (!this.ruleaction.unit.value) {
          this.ruleaction.unit = {
            label: this.ruleaction.unit?.deviceconnect?.device?.devicename, value: this.ruleaction.unit
          };
        }
        if (!this.ruleaction.extCommand.value) {
          this.ruleaction.extCommand = {label: this.ruleaction.extCommand?.name || '', value: this.ruleaction.extCommand};
        };
        this.extCommand = _.cloneDeep(this.ruleaction.extCommand);
        this.section.objtype = 'unit';
      }

    }
    setTimeout(() => {
      this.ruleactionChange.emit(this.ruleaction);
    }, 0);
    //this.cdr.detectChanges();
  }

  onActionChange(event) {
    this.ruleaction = this.globalruleactions[0];
    //this.ruleactionChange.emit(this.ruleaction); // добавьте эту строку
    //this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ruleaction = changes.ruleaction ? changes.ruleaction?.currentValue : this.ruleaction;
    if (changes.ruleaction?.currentValue?.unit) {
      this.section.objtype = 'unit';
      this.isFastProccession = true;
      this.filteredSelUnits = _.cloneDeep(this.itemOptions.units);
      this.filteredSelActions = _.cloneDeep(this.itemOptions.units);
      const ra = changes.ruleaction.currentValue;
      let ec = ra.extCommand;
      if (ec && !ec.value) {
        ec = {label: ec?.name || '', value: ec};
      }
      setTimeout(() => {
        if (this.ruleaction && this.ruleaction.unit && !this.ruleaction.unit.value) {
          this.ruleaction.unit = {label: this.ruleaction.unit?.deviceconnect?.device.devicename, value: this.ruleaction.unit};
        }
        if (this.ruleaction && this.ruleaction.extCommand && !this.ruleaction.extCommand.value) {
          this.ruleaction.extCommand = {label: this.ruleaction.extCommand?.name || '', value: this.ruleaction.extCommand};
        }
      }, 0);
      if (ec) {
        this.extCommand = _.cloneDeep(ec);
      }
    } else if (changes.ruleaction?.currentValue?.contrDeviceParam) {
      this.section.objtype = 'contrdeviceparam';
      this.isFastProccession = true;
      this.filteredSelContrDeviceparams = _.cloneDeep(this.itemOptions.contrdeviceparams);
      this.filteredSelActions = _.cloneDeep(this.itemOptions.contrdeviceparams);
      if (this.ruleaction && this.ruleaction.contrDeviceParam && !this.ruleaction.contrDeviceParam.value) {
        this.ruleaction.contrDeviceParam = {label: this.ruleaction.contrDeviceParam.displayName, value: this.ruleaction.contrDeviceParam};
      }
    }
    for (let propName in changes) {
      if(propName === 'ruleaction'){
        if (this.ruleaction && this.ruleaction.action && !this.ruleaction.action.label) {
          this.ruleaction.action = {label: this.ruleaction.action, value: null};
        }
      }
    }
  }


  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if ( val.isEmpty ) {
      this.values[fieldName] = null;
    }
  }

  get actionIndex(): number {
    const index = this.ruleactions?.indexOf(this.ruleaction);
    return index !== undefined && index > -1 ? index : 0;
  }

  compareById(a, b) {
    if (a === null || b === null) {
      return false;
    }
    if (a && b && (a.id === undefined || b.id === undefined)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  compareByValue(a, b) {
    return a && b && a === b;
  }

  getCompositeValue(value, field) {
    field.forEach(key => value = value[key]);
    return value;
  }

  filterItems(itemInfo) {
    const from = itemInfo.filter.fromField;
    const to = itemInfo.filter.toField;
    const category = itemInfo.filter.categoryField;

    const getIdByKey = (values, key, defaultValue = -1) => {
      if (!values[key] || !values[key].id) {
        return defaultValue;
      }
      return values[key].id;
    };
    const filterObj = (this.itemOptions[itemInfo.filter.options] || []).find(_v => +_v.id === +getIdByKey(this.values, itemInfo.filter.key));

    const items = this.itemOptions[itemInfo.item.options];

    if (filterObj) {
      const filtered = items.filter(
        _item =>
          +extractValue(_item, from, -1) === +extractValue(filterObj, to, -2));
      const categories = {};
      filtered.forEach(_fitem => {
        const categoryName = extractValue(_fitem, category, '');
        categories[categoryName] = categories[categoryName] || [];
        categories[categoryName].push(_fitem);
      });
      return categories;
    }
    return {};
  }

  getValue(values, info) {
    let result = '';
    try {
      result = info.value(values);
    } catch (e) {
      result = '';
    }

    return result;
  }

  ngAfterContentInit() {
    if (this.inTemplates) {
      this.inTemplates.forEach((item) => {
        switch (item.getType()) {
          case 'body':
            this.bodyTemplate = item.template;
            break;
          case 'value':
            this.valueTemplate = item.template;
            break;

        }
      });
    }

    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'body':
          this.bodyTemplate = item.template;
          break;
        case 'value':
          this.valueTemplate = item.template;
          break;

      }
    });

  }

  closeTooltip(tooltip): void {
    tooltip.close();
  }

  copy2clipboard($event, field) {
    copy2clipboard(this.values[field] + '');
  }

  textInput = _.debounce((flag, p) => {
    setTimeout(() => {
      //this.ruleactionChange.emit(this.ruleaction);
    }, 0);
  }, 1000);

  onKeyUp(event, flag) {
    if (event.keyCode === 17) {
      return;
    }
    if (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 37) {
      return;
    }
    const dsp = (this.ruleaction.contrDeviceParam?.label || this.ruleaction.contrDeviceParam?.label === null) ? this.ruleaction.contrDeviceParam.label : this.ruleaction.contrDeviceParam;
    const act = (this.ruleaction.action || this.ruleaction.action === null) ? this.ruleaction.action : '';
    if (flag === 0) {
      this.checkDdlFlag = false;
    } else if (flag === 1) {
      this.checkDdlFlag2 = false;
    }


    if (event.keyCode === 13) {
      if ((flag === 0 && (!dsp || dsp == '')) || (flag === 1 && (!act || act == ''))) {
        this.textInput(flag, false);
      } else if ((flag === 0 && !(dsp && dsp.length > 2)) || (flag === 1 && !(act && act.length > 2))) {
        this.textInput(flag, true);
      }

    } else if ((flag === 0 && dsp && dsp.length >= 3) ||  (flag === 1 && act && act.length >= 3)){
      this.textInput(flag, true);
    }
  }
  filterContrDeviceparamSingle(event) {
    const s = this.inputEL;
    const query = event.query;

    this.filteredContrDeviceparamsSingle = this.filterCDParam(query, this.filteredSelContrDeviceparams);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];

  }

  onRuleActionKeyUp(event: KeyboardEvent) {
    if (!this.isFastProccession) {
      this.onKeyUp(event, 1);
    }
  }

  filterRuleActionByQuery(event) {
    const query = event?.query ?? '';
    this.paramlistApi.getAll(undefined, `allowedForExpression=true&displayName=${query}`, 'GET').subscribe(data => {
      this.filteredRuleActionsSingle = (data as any[]).map(opt => ({label: opt.displayName, value: opt}));
      this.cdr.markForCheck();
    });
  }

  filterRuleActionSingle0(event) {
    const s = this.inputEL;
    const query = event.query || '';
    if (this.allRuleActions?.length > 0 && event.query !== '') {
      this.filteredRuleActionsSingle = [];
      const data = this.allRuleActions.filter(act => act.displayName.indexOf(event.query) != -1);
      data.forEach(opt => {
        this.filteredRuleActionsSingle.push({label: opt.displayName, value: opt});
      });
    } else if (this.allRuleActions?.length > 0 && event.query === '') {
      this.filteredRuleActionsSingle = [];
      this.allRuleActions.forEach(opt => {
        this.filteredRuleActionsSingle.push({label: opt.displayName, value: opt});
      });

    } else {
      this.paramlistApi.getAll(undefined, `allowedForExpression=true&displayName=${event.query}`).subscribe(data => {
        this.allRuleActions = data;
        this.filteredRuleActionsSingle = [];
        data.forEach(opt => {
          this.filteredRuleActionsSingle.push({label: opt.displayName, value: opt});
        });
        this.selectedRuleAction = this.filteredRuleActionsSingle.length === 0 ? query : this.filteredRuleActionsSingle[0];
        this.cdr.markForCheck();
      });
    }

    //this.selectedRuleAction = this.filteredRuleActionsSingle.length === 0 ? query : this.filteredRuleActionsSingle[0];

  }

  extCommandChanged(event, globalRule) {
    if (globalRule && globalRule.extcommands) {
      const extCmd = globalRule.extcommands?.filter(cmd => cmd.id === event.value)[0];
      globalRule.action = extCmd?.data;
    }
  }

  filterRuleCmdSingle(event, id) {
    const query = event.query ?? this.extCommand?.label ?? '';

    const deviceId = this.ruleaction.unit?.value?.deviceconnect?.device?.id ?? this.globalrule?.object?.id;
    if (!deviceId) {
      this.filteredRuleCmdsSingle = [];
      return;
    }

    if (this.id_keep === deviceId && this.filteredRuleCmdsSingle_keep?.length) {
      const searchTerm = typeof query === 'string' ? query.trim().toLowerCase() : '';
      if (searchTerm) {
        this.filteredRuleCmdsSingle = this.filteredRuleCmdsSingle_keep.filter(
          item => item.label?.toLowerCase().includes(searchTerm)
        );
      } else {
        this.filteredRuleCmdsSingle = [...this.filteredRuleCmdsSingle_keep];
      }
      return;
    }

    this.id_keep = deviceId;
    const url = `extcommand?deviceId=${deviceId}`;
    this.http.get(url).subscribe({
      next: (data: any[]) => {
        this.filteredRuleCmdsSingle = data.map(opt => ({
          label: opt?.name ?? '',
          value: opt
        }));
        this.filteredRuleCmdsSingle_keep = [...this.filteredRuleCmdsSingle];
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Failed to load extcommands', error);
        this.filteredRuleCmdsSingle = [];
        this.filteredRuleCmdsSingle_keep = [];
      }
    });
  }



  filterExpressionParams(event): void {
    const query = event.query || '';

    this.paramlistApi.getAll(undefined, `allowedForExpression=true&displayName=${event.query}`).subscribe(data => {
      this.itemOptions.semuxParams = [];
      data.forEach(opt => {
        this.itemOptions.semuxParams.push({label: opt.displayName, value: opt});
      });
      this.cdr.markForCheck();
    });

  }


  filterRuleActionSingle(event) {

    const s = this.inputEL;
    this.filteredRuleActionsSingle = this.filterCDParam(this.ruleaction?.action, this.filteredSelActions);
    this.selectedRuleAction = this.filteredRuleActionsSingle.length === 0 ? this.ruleaction?.action : this.filteredRuleActionsSingle[0];
  }

  filterCDParam(query, params: any[]): any[] {

    const filtered: any[] = [];

    for (let i = 0; i < params.length; i++) {
      const param = params[i];
      if (param && query && param.displayName && param.displayName.toLowerCase().indexOf((query + '').toLowerCase()) !== -1) {
        filtered.push({label: param.displayName, value: param});
      } else if (!query && param && param.displayName) {
        filtered.push({label: param.displayName, value: param});
      } else if (query && query.length === 0) {
        filtered.push({label: param.displayName, value: param});
      }
    }
    return filtered;
  }

  filterUnitSingle(event) {

    const query = event.query;
    this.filteredUnitsSingle = this.filterUnit(query, this.filteredSelUnits);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];
  }

  filterUnit(query, units: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < units.length; i++) {
      const unit = units[i];
      const paramname = unit.deviceconnect?.connectname;
      if (unit && query && paramname && paramname.toLowerCase().indexOf((query + '').toLowerCase()) !== -1) {
        filtered.push({label: paramname, value: unit});
      } else if (!query && unit && paramname) {
        filtered.push({label: paramname, value: unit});
      } else if (query.length === 0) {
        filtered.push({label: paramname, value: unit});
      }
    }
    return filtered;
  }



  checkDdl(event, flag) {

    if (!this.checkDdlFlag) {
      this.checkDdlFlag = true;
      const dsp = (this.ruleaction.contrDeviceParam?.label || this.ruleaction.contrDeviceParam?.label === null) ? this.ruleaction.contrDeviceParam.label : this.ruleaction.contrDeviceParam;
      if ((flag === 0 && (!dsp || dsp == ''))) {
        this.textInput(flag, false);
      } else if ((flag === 0 && !(dsp && dsp.length > 2))) {
        this.textInput(flag, true);
      }
    }
  }

  checkDdl2(event, flag) {

    if (!this.checkDdlFlag2) {
      this.checkDdlFlag2 = true;
      const act = (this.ruleaction.action || this.ruleaction.action === null) ? this.ruleaction.action : '';
      if (flag === 1 && (!act || act == '')) {
        this.textInput(flag, false);
      } else if (flag === 1 && !(act && act.length > 2)) {
        this.textInput(flag, true);
      }
    }
  }

  checkDdl3(event, flag) {

    if (!this.checkDdlFlag2) {
      this.checkDdlFlag2 = true;
      const act = (this.ruleaction.action || this.ruleaction.action === null) ? this.ruleaction.action : '';
      if (flag === 2 && (!act || act == '')) {
        this.textInput(flag, false);
      } else if (flag === 2 && !(act && act.length > 2)) {
        this.textInput(flag, true);
      }
    }
  }

  switchRuleActionRootable(event) {
    //event.root = !event.root;
    this.root.emit(event);
  }

  saveAction(ruleaction) {
    this.save.emit(ruleaction);
  }

  deleteAction(ruleaction) {
    this.delete.emit(ruleaction);
  }

  plusAction(ruleaction) {
    this.create.emit(ruleaction);
  }

  plusCondition(ruleaction) {
    this.createCondition.emit(ruleaction);
  }

  getTitle(str) {
    if (str) {return str;}
    return null;
  }

  isSaveAvailable() {

    const dsp = this.ruleaction.contrDeviceParam?.label ? this.ruleaction.contrDeviceParam.label : this.ruleaction.contrDeviceParam;
    const act = this.ruleaction.action ? this.ruleaction.action : '';
    if (dsp && dsp.length > 1) {
      this.hasNotSavedValue = false;
    } else {
      this.hasNotSavedValue = true;
    }
    if (act && act.length > 1) {
      this.hasNotSavedParameter = false;
    } else {
      this.hasNotSavedParameter = true;
    }

  }

  async onActionAdd() {
    const storageObj = this.localStorageApi.load(true, 'paramlists');
    /*const storageString = window.localStorage.getItem('paramlists');*/
    const selectedItems = storageObj ? storageObj : {
      sortField: 'displayName',
      sortOrder: 1,
      selection: []
    };
    const selections = [];
    if (this.globalruleactions && this.globalruleactions.length > 0) {
      this.globalruleactions.forEach(rule => {
        selections.push((rule as any).contrDeviceParam);
      });
    }
    selectedItems.selection = selections;
    this.localStorageApi.save(true, 'paramlists', JSON.stringify(selectedItems));
    /*window.localStorage.setItem('paramlists', JSON.stringify(selectedItems));*/


    const objects = await firstValueFrom(this.objectsShortestApi.getAll());
    this.refWindow = this.dialogService.open(ComposeBusinesscontrparamsModalComponent, {
      data: {
        ...this.route.snapshot.data,
        objects,
        config: {
          toolbar: [],
          paramType: 'DEVICE',
          allowedForExpression: true,
          deviceType: 'CONTROLLER',
          selectionMode: 'single',
          returnParams: true,
          useSimpleObjectTree: true
        }
      },
      header: gettext('Select params'),
      showHeader: false,
      width: this.deviceService.isDesktop() ? '70%' : '100%',
      height: this.deviceService.isDesktop() ? '80vh' : '100vh'
    });

    this.refWindow.onClose.subscribe((data) => {

      if (data && data.length > 0) {
        const s = [];
        data.forEach(contrDeviceParam => {
          this.globalruleactions = [];
          const tmp = (this.globalruleactions || []).filter(rule => (rule as any).contrDeviceParam?.id === contrDeviceParam.id);
          if (tmp.length === 0) {
            s.push({label: contrDeviceParam.displayName, value: contrDeviceParam});
          }
        });
        //this.globalruleactions = (this.globalruleactions || []).concat(s);
        this.ruleaction.contrDeviceParam = s[0];
        setTimeout(() => {
          this.ruleactionChange.emit(this.ruleaction);
        }, 0);
      }
    });
  }


  async onActionAddValue() {
    const objects = await firstValueFrom(this.objectsShortestApi.getAll());
    this.refWindow = this.dialogService.open(ComposeBusinesscontrparamsModalComponent, {
      data: {
        ...this.route.snapshot.data,
        objects,
        config: {
          toolbar: [],
          paramType: 'DEVICE',
          allowedForExpression: true,
          deviceType: 'CONTROLLER',
          selectionMode: 'single',
          returnParams: true,
          useSimpleObjectTree: true
        }
      },
      header: gettext('Select params'),
      showHeader: false,
      width: this.deviceService.isDesktop() ? '70%' : '100%',
      height: this.deviceService.isDesktop() ? '80vh' : '100vh'
    });

    this.refWindow.onClose.subscribe((data) => {
      if (data && data.length > 0) {
        const param = data[0];
        this.ruleaction.action = {label: param.displayName, value: param};
        setTimeout(() => {
          this.ruleactionChange.emit(this.ruleaction);
        }, 0);
      }
    });
  }

  onActionAdd2() {
    const storageObj = this.localStorageApi.load(true, 'unitlists');
    /*const storageString = window.localStorage.getItem('unitlists');*/
    const selectedItems = storageObj ? storageObj : {
      sortField: 'displayName',
      sortOrder: 1,
      selection: []
    };
    const selections = [];
    if (this.globalruleactions && this.globalruleactions.length > 0) {
      this.globalruleactions.forEach(rule => {
        selections.push((rule as any).contrDeviceParam);
      });
    }
    selectedItems.selection = selections;
    this.localStorageApi.save(true, 'unitlists', JSON.stringify(selectedItems));
    /*window.localStorage.setItem('unitlists', JSON.stringify(selectedItems));*/


    setTimeout(async () => {
    const objects = await firstValueFrom(this.objectsShortestApi.getAll());
    this.refWindow = this.dialogService.open(ComposeUnitsModalComponent, {
      data: {
        ...this.route.snapshot.data,
        objects,
        config: {
          toolbar: [],
          returnParams: true,
          query: 'hasExtCommand=true',
          extCommand: true,
          selectionMode: 'single',
          singleSelection: false,
          limit: 255,
          useSimpleObjectTree: true,
          flexScroll: false
        }
      },
      header: gettext('Select params'),
      showHeader: false,
      width: this.deviceService.isDesktop() ? '70%' : '100%',
      height: this.deviceService.isDesktop() ? '80vh' : '100vh'
    });

    this.refWindow.onClose.subscribe((data) => {

      if (data && data.length > 0) {
        const s = [];
        const s2 = [];
        data.forEach(unit => {
          this.globalruleactions = [];
          const tmp = (this.globalruleactions || []).filter(rule => (rule as any).unit?.id === unit.id);
          if (tmp.length === 0) {
            s.push({
              action: null,
              contrdeviceparam: null,
              unit: unit.unit,
              extcommands: unit.extcommands,
              globalRule: this.globalrule
            });
          } else {
            s2.push((this.globalruleactions || []).filter(rule => (rule as any).unit?.id === unit.id));
            // this.globalruleactions = this.globalruleactions.filter(rule => (rule as any).unit?.id !== unit.id);
            s.push({
              action: null,
              contrdeviceparam: null,
              unit: unit.unit,
              extcommands: unit.extcommands,
              globalRule: this.globalrule
            });
          }
        });
        this.globalruleactions = [];
        this.globalruleactions = (this.globalruleactions || []).concat(s);
        this.ruleaction.unit = {label: this.globalruleactions[0].unit?.deviceconnect?.device?.devicename, value: this.globalruleactions[0].unit};
        this.ruleaction.extCommand = {label: '', value: null};
        this.extCommand = {label: '', value: null};
        //this.ruleaction.action = {label: null, value: null};
        setTimeout(() => {
          this.ruleactionChange.emit(this.ruleaction);
        }, 0);
        //this.globalruleactions2 = s2;
      }
    });
    }, 0);
  }
  onTabChange(tab) {
    if (tab === 'unitstab') {
      this.section.objtype = 'unit';
    } else {
      this.section.objtype = 'contrdeviceparam';
    }

  }

  checkExtCommand() {
    if (this.extCommand?.value?.id) {
      this.ruleaction.extCommand = _.cloneDeep(this.extCommand);
    } else {
      this.ruleaction.extCommand.label = null;
      this.ruleaction.extCommand.value = null;

    }
    setTimeout(() => {
      this.ruleactionChange.emit(this.ruleaction);
    }, 0);
  }


}
